// Translation file for KepzesCelja component
// Contains all UI text in Hungarian and English

export const KEPZESCELJA_TRANSLATIONS = {
    hu: {
        esgTitle: "ESG 1.1 Minőségpolitika",
        pageTitle: "1. A képzés",
        
        section1: {
            title: "1.1. A képzés célja"
        },
        
        section2: {
            title: "1.2. A szak állapota",
            noteLabel: "Megjegyzés (opcionális):"
        },
        
        section3: {
            title: "1.3. A szak illeszkedése a kar missziójához",
            description: "Kérjük jelölje meg, hogy az adott félévben a szak milyen módon járult hozzá a kar küldetéséhez és stratégiai prioritásaihoz (több válasz is jelölhető)",
            subtitle: "A szak hozzájárult a következő területekhez"
        },

        section4: {
            title: "1.4. Kérjük jelölje meg, hogy a szak mivel járul hozzá  a közösség jólétéhez (társadalmi hatás) (több válasz is jelölhető)",
            noteLabel: "Megjegyzés (opcionális):"
        },

        section5: {
            title: "1.5. Kompetenciatérkép"
        },

        section6: {
            title: "1.6. A képzés bemeneti követelményei"
        },

        section7: {
            title: "1.7. Képzési és kimeneti követelmények"
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        esgTitle: "ESG 1.1 Quality Policy",
        pageTitle: "1. The Programme",
        
        section1: {
            title: "1.1. Objective of the Programme"
        },
        
        section2: {
            title: "1.2. Status of the Programme",
            noteLabel: "Comments (optional):"
        },
        
        section3: {
            title: "1.3. Alignment of the Programme with the Faculty’s Mission",
            description: "Please indicate how the programme contributes to the Faculty’s mission and strategic priorities in the given semester (multiple answers may be selected)",
            subtitle1: "The programme contributed to the following areas:"
        },

        section4: {
            title: "1.4. Please indicate how this field contributes to the well-being of the community (social impact) (multiple answers may be selected)",
            noteLabel: "Comments (optional):"
        },

        section5: {
            title: "1.5. Competency Framework"
        },

        section6: {
            title: "1.6. Entry Requirements of the Programme"
        },

        section7: {
            title: "1.7. Programme Requirements and Intended Learning Outcomes"
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};